import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import fetchAPI from '../../common/fetchAPI';
import { RootState } from '../../app/store';
import { MilestoneStateClass } from './interfaces/MilestoneStateClass';
import { setMilestoneStatus } from '../../common/timeLiveFunction';

const initialState: MilestoneStateClass = {
    status: 'idle',
    isLoading: true,
    isLoadingProjectSummary: false,
    isReload: false,
    accountProjectId: 0,
    accountProjectMilestoneId: 0,
    milestoneList: [],
    isCanvasFromMilestone: false,
    isCanvasFrom: 'Milestone'
}

interface IThunkApi {
    state: {
        milestone: MilestoneStateClass;
    },
}

export const getProjectMilestoneList = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Milestone/getProjectMilestoneList',
        async (arg, thunkApi) => {
            const response = await fetchAPI(`api/V2/Projects/GetAllProjectMilestoneByProjectId/${arg}`, `Get`, '', true);
            const json = await response.json();
            return json;
        }
    )

export const addAccountProjectMilestone = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Milestone/addAccountProjectMilestone',
        async (arg, thunkApi) => {
            const { accountProjectId } = thunkApi.getState().milestone;
            const response = await fetchAPI(`api/V2/Projects/Milestone/${accountProjectId}`, 'POST', arg, true);
            const json = await response.json();
            return json;
        }
    )

export const updateAccountProjectMilestone = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Milestone/updateAccountProjectMilestone',
        async (arg, thunkApi) => {
            const { accountProjectId, accountProjectMilestoneId } = thunkApi.getState().milestone;
            const response = await fetchAPI(`api/V2/Projects/Milestone/${accountProjectId}/${accountProjectMilestoneId}`, 'POST', arg, true);
            const json = await response.json();
            return json;
        }
    )

export const updateAccountProjectMilestoneStatus = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Milestone/updateAccountProjectMilestoneStatus',
        async (arg, thunkApi) => {
            let { IsDisabled, AccountProjectMilestoneId } = arg
            const response = await fetchAPI(`api/V2/Projects/UpdateAccountProjectMilestoneStatus/${IsDisabled}/${AccountProjectMilestoneId}`, 'POST', true);
            const json = await response.json();
            return json;
        }
    )

export const deleteAccountProjectMilestone = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Milestone/deleteAccountProjectMilestone',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/Projects/Milestone/' + arg, 'DELETE', '', true);
            const json = await response.json();
            return json;
        }
    )

export const milestoneSlice = createSlice({
    name: 'milestone',
    initialState,
    reducers: {
        updateIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        updateIsLoadingProjectSummary: (state, action: PayloadAction<boolean>) => {
            state.isLoadingProjectSummary = action.payload;
        },
        updateAccountProjectId: (state, action: PayloadAction<any>) => {
            state.accountProjectId = action.payload;
        },
        updateAccountProjectMilestoneId: (state, action: PayloadAction<any>) => {
            state.accountProjectMilestoneId = action.payload;
        },
        updateIsCanvasFromMilestone: (state, action: PayloadAction<any>) => {
            state.isCanvasFromMilestone = action.payload;
        },
        updateMilestone: (state, action: PayloadAction<any>) => {
            state.accountProjectMilestoneId = action.payload.accountProjectMilestoneId;
            state.isCanvasFromMilestone = action.payload.isCanvasFromMilestone;
        },
        updateIsCanvasFrom: (state, action: PayloadAction<any>) => {
            state.isCanvasFrom = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getProjectMilestoneList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getProjectMilestoneList.fulfilled, (state, action) => {
                state.status = 'idle';
                if (action.payload.length > 0) {
                    action.payload.map((item: any) => {
                        item.MilestoneStatus = setMilestoneStatus(item.MilestoneDate, item.Completed)?.text
                    });
                }
                state.milestoneList = action.payload;

                state.isLoading = false;
            })
            .addCase(getProjectMilestoneList.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(updateAccountProjectMilestoneStatus.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateAccountProjectMilestoneStatus.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Number(payload.Id) > 0) {
                    state.milestoneList.map((item: any) => {
                        if (item.AccountProjectMilestoneId == Number(payload.Id)) {
                            item.IsDisabled = (item.IsDisabled === "No" ? "Yes" : "No");
                        }
                    })
                }
                state.isLoading = false;
            })
            .addCase(updateAccountProjectMilestoneStatus.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(addAccountProjectMilestone.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(addAccountProjectMilestone.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isReload = state.isReload ? false : true;
                state.isLoading = false;
            })
            .addCase(addAccountProjectMilestone.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(updateAccountProjectMilestone.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateAccountProjectMilestone.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isReload = state.isReload ? false : true;
                state.isLoading = false;
            })
            .addCase(updateAccountProjectMilestone.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(deleteAccountProjectMilestone.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteAccountProjectMilestone.fulfilled, (state, action) => {
                state.milestoneList = state.milestoneList.filter(x => x.AccountProjectMilestoneId != Number(action.payload.Id));
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(deleteAccountProjectMilestone.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
    }
})
export const {
    updateIsLoading, updateAccountProjectId, updateAccountProjectMilestoneId, updateIsCanvasFromMilestone, updateMilestone, updateIsLoadingProjectSummary, updateIsCanvasFrom
} = milestoneSlice.actions

export const MilestoneState = (state: RootState) => state.milestone
export default milestoneSlice.reducer